// ===================================================================
// KAIXO - Aviso de actualización disponible
// ===================================================================
// Al arrancar consulta /api/version. Si el versionCode del APK instalado
// es menor que el latest, muestra un banner no bloqueante invitando a
// actualizar. Si además el backend devuelve forceUpdate=true, muestra
// un overlay bloqueante (usado para bugs graves o breaking changes).
// ===================================================================

import React, { useEffect, useState } from 'react';
import './UpdateBanner.css';

const API_URL = process.env.REACT_APP_API_URL || 'https://backend-dlmm.onrender.com/api';

// Versión del APK actual. El build inyecta estos valores al compilar;
// si no están, caemos a defaults conservadores.
const CURRENT_VERSION_CODE = parseInt(process.env.REACT_APP_VERSION_CODE || '2', 10);

async function getInstalledVersionCode() {
    // En web: usamos el valor de build. En APK Capacitor 8 podríamos pedir
    // App.getInfo() pero evitamos requerir el plugin para no inflar bundle.
    return CURRENT_VERSION_CODE;
}

function UpdateBanner() {
    const [state, setState] = useState(null); // { has, force, url, latestName }
    const [dismissed, setDismissed] = useState(false);

    useEffect(() => {
        let cancelled = false;
        (async () => {
            try {
                const res = await fetch(`${API_URL}/version`, { cache: 'no-store' });
                if (!res.ok) return;
                const data = await res.json();
                const installed = await getInstalledVersionCode();
                const latest = parseInt(data.latestAndroidVersionCode || 0, 10);
                const minReq = parseInt(data.minAndroidVersionCode || 0, 10);
                if (cancelled) return;
                if (installed < minReq || data.forceUpdate === true) {
                    setState({ has: true, force: true, url: data.playStoreUrl, latestName: data.latestAndroidVersionName });
                } else if (installed < latest) {
                    setState({ has: true, force: false, url: data.playStoreUrl, latestName: data.latestAndroidVersionName });
                }
            } catch { /* silencioso, no queremos molestar al user por fallo de chequeo */ }
        })();
        return () => { cancelled = true; };
    }, []);

    if (!state?.has) return null;

    const openStore = () => {
        try { window.open(state.url, '_blank'); } catch {}
    };

    // Modo bloqueante: ocupa toda la pantalla, sin botón de cerrar
    if (state.force) {
        return (
            <div className="kaixo-update-overlay">
                <div className="kaixo-update-card">
                    <div className="kaixo-update-icon">⬆️</div>
                    <h2>Actualización necesaria</h2>
                    <p>Para seguir usando KAIXO necesitas instalar la última versión ({state.latestName}).</p>
                    <button className="kaixo-update-cta" onClick={openStore}>Actualizar ahora</button>
                </div>
            </div>
        );
    }

    // Modo no bloqueante: banner en la parte superior, descartable
    if (dismissed) return null;
    return (
        <div className="kaixo-update-banner">
            <span>Hay una versión nueva ({state.latestName}) disponible.</span>
            <button className="kaixo-update-link" onClick={openStore}>Actualizar</button>
            <button className="kaixo-update-close" onClick={() => setDismissed(true)} aria-label="Cerrar">×</button>
        </div>
    );
}

export default UpdateBanner;
